import { WidgetProps } from "@rjsf/utils";

export const BooleanWidget = (props: WidgetProps) => {
  return (
    <div className={`boolean-container container`}>
      <input
        type="checkbox"
        className={`input-boolean`}
        checked={props.value || false}
        onChange={(e) => props.onChange?.(e.target.checked)}
        required={props.required ?? false}
      />
    </div>
  );
};
